import React from 'react'
import { connect } from 'react-redux'
import SearchBar from 'tickets/components/SearchBar'
import { injectIntl } from 'react-intl'
import locationOperations from 'tickets/redux/modules/location/operations'
import passengersOperations from 'tickets/redux/modules/passengers/operations'
import searchResponsesOperations from 'tickets/redux/modules/searchResponses/operations'
import { showPassengerOptions } from 'tickets/redux/modules/modals.js'
import { getLanguageCode } from 'tickets/redux/modules/user/selectors'
import { logEvent } from 'common/redux/modules/logging'

import {
  getOriginLongName,
  getDestinationLongName,
  getOriginShortName,
  getDestinationShortName,
} from 'tickets/redux/modules/location/selectors'
import { getPax, getAreThereTravelCards, getPaxCount, getTravelCardCount }
  from 'tickets/redux/modules/passengers/selectors'
import {
  getSearchIsReturn,
  getOriginKind,
  getDestinationKind,
} from 'tickets/redux/modules/searchParams/selectors'
import {
  getSearchOrigin,
  getSearchDestination,
  getSearchOutboundDateTime,
  getSearchInboundDateTime,
} from 'tickets/redux/modules/router/selectors'
import { autocompleteEndpoint } from 'common/utils/paths'

const mapStateToProps = state => ({
  origin: getSearchOrigin(state),
  destination: getSearchDestination(state),
  originLng: getOriginLongName(state),
  originKind: getOriginKind(state),
  destinationLng: getDestinationLongName(state),
  originShrt: getOriginShortName(state),
  destinationShrt: getDestinationShortName(state),
  destinationKind: getDestinationKind(state),
  oDateTime: getSearchOutboundDateTime(state),
  iDateTime: getSearchInboundDateTime(state),
  isReturn: getSearchIsReturn(state),
  pax: getPax(state),
  paxCount: getPaxCount(state),
  areTravelCards: getAreThereTravelCards(state),
  travelCardCount: getTravelCardCount(state),
  autocompleteEndpoint,
  locale: getLanguageCode(state),
  languageCode: getLanguageCode(state),
})

const mapDispatchToProps = {
  origLngName: locationOperations.origLngName,
  destLngName: locationOperations.destLngName,
  updateUrl: searchResponsesOperations.updateUrl,
  onPassengerOptionsClickDesktop: showPassengerOptions,
  onPassengerMinus: passengersOperations.minusPassenger,
  onPassengerAdd: passengersOperations.addPassenger,
  onPassengerUpdate: passengersOperations.updatePassenger,
  onOrigDest: passengersOperations.fetchPassengerOptions,
  logEvent,
}

const SearchBarContainer = props => <SearchBar {...props} />

export default injectIntl(connect(
  mapStateToProps,
  mapDispatchToProps,
)(SearchBarContainer))
